export class Constants {
    public static SEARCH_DESCRIPTION = "Browse over 50 million SKUs from the world's biggest suppliers, brands, and retailers.";
}
